import {ISection} from "../../model/B2CInfo";
import './SecurityItem.css'
import '../../MainScreen.css'
import SectionHeader from "../../SectionHeader";
import {ISecurityItem} from "./ISecurityItem";
import MobileSectionHeader from "../../MobileSectionHeader";
import blueArrow from '../../../imgs/blue_arrow.png'

interface ISecurityItemProps {
    section: ISection
    mobile: boolean
}

export default function SecurityItem(props: ISecurityItemProps) {

    if (props.mobile) {
        let items = (props.section.data as Array<ISecurityItem>).map((item) => {
            return <div className="Security_section_item_mobile">
                <img src={item.icon} className="Security_section_item_mobile__img"/>
                <div className="Security_section_item_mobile__title">{item.title}</div>
                <div className="Security_section_item_mobile__subtitle">{item.subtitle}</div>
                {
                    (item.link && item.link_title) &&
                    <a href={item.link} target="_blank" className="Security_section_item_link_container">
                        <div className="Security_section_item_link_container__title_mobile">{item.link_title}</div>
                        <img src={blueArrow} className="Security_section_item_link_container__image_mobile"/>
                    </a>
                }
            </div>
        });
        return <div className="Section_container_mobile">
            <MobileSectionHeader section={props.section}/>
            <div className="Security_items_container_mobile">
                {items}
            </div>
        </div>
    } else {
        let items = (props.section.data as Array<ISecurityItem>).map((item) => {
            return <div className="Security_section_item">
                <img src={item.icon} className="Security_section_item_icon"/>
                <div className="Security_section_item_title">{item.title}</div>
                <div className="Security_section_item_subtitle">{item.subtitle}</div>
                {
                    (item.link && item.link_title) &&
                    <a href={item.link} target="_blank" className="Security_section_item_link_container">
                        <div className="Security_section_item_link_container__title">{item.link_title}</div>
                        <img src={blueArrow} className="Security_section_item_link_container__image"/>
                    </a>
                }
            </div>
        });
        return <div className="Security_item">
            <div className="Section_container">
                <SectionHeader section={props.section}/>
                <div className="Security_item_container">
                    {items}
                </div>
            </div>
        </div>
    }
}